import { render } from "./UserCheckStorico.vue?vue&type=template&id=baeb50ee&scoped=true"
import script from "./UserCheckStorico.vue?vue&type=script&lang=js"
export * from "./UserCheckStorico.vue?vue&type=script&lang=js"

import "./UserCheckStorico.vue?vue&type=style&index=0&id=baeb50ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baeb50ee"]])

export default __exports__